<template>
  <div class="container">
    <div class="tab">
      <div>在途预报</div>
      <div>现车情况</div>
    </div>
    <div class="content">
      <dv-scroll-board :config="config" style="height:300px;" />
    </div>
  </div>
</template>
<script>
export default {
  props: {},
  components: {},
  data() {
    return {
      config: {
        headerBGC:'#274c74',
        headerHeight:50,
        oddRowBGC:'',
        evenRowBGC:'#143A74',
        header: ['客户名称', '货物品名', '车种','辆数','空重','车站'],
        data: [
          ['行1列1', '行1列2', '行1列3','辆数','空重','车站'],
          ['行2列1', '行2列2', '行2列3','辆数','空重','车站'],
          ['行3列1', '行3列2', '行3列3','辆数','空重','车站'],
          ['行4列1', '行4列2', '行4列3','辆数','空重','车站'],
          ['行5列1', '行5列2', '行5列3','辆数','空重','车站'],
          ['行6列1', '行6列2', '行6列3','辆数','空重','车站'],
          ['行7列1', '行7列2', '行7列3','辆数','空重','车站'],
          ['行8列1', '行8列2', '行8列3','辆数','空重','车站'],
          ['行9列1', '行9列2', '行9列3','辆数','空重','车站'],
          ['行10列1', '行10列2', '行10列3','辆数','空重','车站']
        ]
      },
      
    };
  },

  created() {},
};
</script>
<style scoped>
.container {
  width: 100%;
  height: 100%;
  background: url('../../../../assets/images2/bg3.png') no-repeat;
  background-size: 100% 100%;
}
.tab{
  width: 100%;
  height: 70px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  padding: .5% 3% 0%;
  box-sizing: border-box;
}
.tab div{
  font-size: 25px;
  color: white;
  position: relative;
  margin-right: 5%;
}
.content{
  padding: 0% 3%;
}
.tab div::before{
  content: '';
  width: 100%;
  height: 4px;
  background: white;
  position: absolute;
  bottom: -33%;
  left: 0;
}
</style>
